import React from 'react';
import { RouteType } from '../types';
import { IntuitContainer } from '../../../Pages/Intuit/IntuitContainer';
import { IntuitLayout } from '../../../Pages/Intuit/IntuitLayout';

export const routes: Array<RouteType> = [
	{
		path: '/intuit/',
		element: <IntuitContainer Layout={IntuitLayout} />,
	},
];
